import { appConstants, THOUSAND, SIXTY, TEN } from './appConstants';
import { bffRoutes } from './configuration';

const { MANULIFE_URL, TIMEOUT_LOGOUT, MAX_ACTIVITY_LOGOUT, MAX_CIAM_ACTIVITY_LOGOUT, LOGOUT } = appConstants;

let { BEGIN_MAX_ACTIVITY_TIME, END_MAX_ACTIVITY_TIME } = appConstants;

export const setTime = () => {
  if (sessionStorage.hasOwnProperty('maxSessionExpirationTime')) {
    const maxSessionExpirationTime = sessionStorage.getItem('maxSessionExpirationTime');

    // Calculate the time remaining before the CIAM session expiration time
    // And set to END_MAX_ACTIVITY_TIME
    END_MAX_ACTIVITY_TIME = Math.floor((Date.parse(maxSessionExpirationTime) - Date.now()) / THOUSAND);

    // 1 Minute before the max session expiration time
    BEGIN_MAX_ACTIVITY_TIME = END_MAX_ACTIVITY_TIME - SIXTY;
  }
};

/**
 * Redirect the user to manulife website by user is authenicated or not.
 * @param {*} isAuthenticated
 */
export const onRedirectAfterExit = (isAuthenticated) => {
  if (!isAuthenticated) {
    window.location.href = MANULIFE_URL;
  } else {
    window.close();
  }
};
/**
 * Format the given input time into minute:seconds [00:00]
 * @param {Number} time - milliseconds
 */
export const getFomattedTime = (time) => {
  if (time < 0) {
    return `00:00`;
  }

  const zeroStr = '0';
  let minutes = parseInt((time / (THOUSAND * SIXTY)) % SIXTY, 10);
  let seconds = parseInt((time / THOUSAND) % SIXTY, 10);

  //if values are less than 10, preppend 0.
  minutes = minutes < TEN ? zeroStr + minutes : minutes;
  seconds = seconds < TEN ? zeroStr + seconds : seconds;

  return `${minutes}:${seconds}`;
};
/**
 *check if time is between begin of max activity and end of max activity
 * begin time would be 5 mins before end time.
 * @param {*} time is in seconds
 */
export const isTimeBetweenBeginAndEndMaxActivity = (time) =>
  time > BEGIN_MAX_ACTIVITY_TIME && time < END_MAX_ACTIVITY_TIME;

/**
 * check if time passed the max activity
 * @param {*} time
 */
export const isTimePassedEndMaxActivity = (time) => time > END_MAX_ACTIVITY_TIME;

/**
 * check if refresh the cookie call is successful.
 * @param {object} data
 */
export const isRefreshCookieCallSuccess = (data) =>
  data.result && !data.isLoading && !data.error && data.url === bffRoutes.getRefreshCookie();

export const isLogoutCallSuccess = (data) =>
  data.result && !data.isLoading && !data.error && data.url === bffRoutes.getLogout();

export const isSaving = (data, url) => data.isLoading && data.url === url;

export const getModalBodyByAuth = (isAuth, lang) => (isAuth ? lang.CONTENT_WITH_AUTH : lang.CONTENT_WITHOUT_AUTH);

/**
 * Get display timer to display on idle timer and max activity modal.
 * @param {bool} isMaxActivityReach []
 * @param {number} remainingTimeModal
 * @param {number} seconds
 */
export const getDisplayTimer = (isMaxActivityReach, remainingTimeModal, seconds) => {
  return !isMaxActivityReach
    ? getFomattedTime(remainingTimeModal)
    : getFomattedTime(Math.floor(END_MAX_ACTIVITY_TIME - seconds) * THOUSAND);
};
/**
 * get Language Content for Logout page based on request coming from whihc page.
 * @param {Object} langContent
 * @param {Object} state
 */
export const getLogoutLang = (langContent, state) => {
  let lang;
  switch (state.requestPage) {
    case MAX_ACTIVITY_LOGOUT:
      lang = langContent[MAX_ACTIVITY_LOGOUT];
      break;
    case MAX_CIAM_ACTIVITY_LOGOUT:
      lang = langContent[MAX_CIAM_ACTIVITY_LOGOUT];
      break;
    case TIMEOUT_LOGOUT:
      lang = langContent[TIMEOUT_LOGOUT];
      break;
    default:
      lang = langContent[LOGOUT];
  }
  return lang;
};
